export default {
  // 全局设置=global settings
  globalSettings: {
    roleAuthInfo:
      'Role permissions control which module functions can be used by users and which data permissions can be viewed;Roles are created in role management.',
    dataAuth: 'Data authority',
    funAuth: 'Function authority',
    seeMyData: 'View only personal data.',
    seeMyDepartment: 'View departmental data ',
    seeCompanyData: 'View company-wide data',
    conteneUpdateIsSave: 'Content has been updated, do you need to save?',
    pageAuthInfo:
      'Display all roles of the company, with the page layout used when viewing data of different business types through roles.',
    dataShareInfo:
      'A data set that meets a criteria is automatically shared as a data area to a role、member or organization.',
    dataShare: 'Data share',
    ruleContion: 'Rule contion',
    anyContion: 'Any contion',
    zhidingContion: 'Specified requirements',
    matchContion: 'Select match condition',
    shareTarget: 'Share target',
    VisitRule: 'Access authority',
    selectSharer: 'Please select the sharer.',
    delRuleIsGoon: 'This action will permanently delete the rule, continue or not?',
    recordLockingInfo: 'Automatically locks data that meets a condition.',
    lockingRecordAfter: 'After locking the record',
    recordLocking: 'Record locking',
    dontEdit: 'Not editable ',
    dontShare: 'Unshareable',
    dontTransPer: 'Non-transferable principal',
    dontZhuanhuan: 'Nonconvertible',
    dontDel: 'Undeletable',
    referenceMappingInfo:
      'Applied to the association relation type field, setting the association relation can rely on the field contents in the association field module to the current module.',
    controlField: 'Control field',
    firstControlField: 'First Control field',
    secondControlField: 'Second Control field',
    referenceMapping: 'Dependence mapping',
    mappingField: 'Mapping field',
    duiyingField: 'Corresponding field',
    addIsRepeatEdit: 'The new rule already exists and please use the edit function.',
    controlFielNotEmpty: 'Control field cannot be empty.',
    firstControlFielNotEmpty: 'First-level control field cannot be empty.',
    secondControlFielNotEmpty: 'Second-level control field cannot be empty.',
    controlFieldDontSame:
      'First-level control field and second-level control field cannot be the same.',
    mapDuiyingFieldNotEmpey: 'The corresponding fields of the mapping field cannot be empty.',
    mapDelIsgoon: 'This operation will be permanently deleted, whether to continue?',
    referenceYilaiInfo:
      'Applied to fields of association type to implement data filtering between two association relationships',
    yilaiField: 'Depend on the field',
    referenceYilai: 'Associated rely on',
    controlAndYilaiField:
      'Control and dependency fields cannot be controlled and dependent on each other.',
    yilaiFieldNotEmpty: 'The dependent field cannot be null.',
    controlAndYilaiDontLike: 'Control and dependency fields cannot be aligned.',
    controlAndControl2DontLike:
      'First-level control options and second-level control options cannot be aligned.',
    optionFieldYilaiInfo:
      'Apply to drop-down options type field, select a control field and a dependency field for filtering dependencies.',
    optionYilai: 'The options depend on',
    optionFieldYilai: 'Option field dependencies',
    controlOption: 'Control option',
    firstControlOption: 'First control option',
    secondControlOption: 'Second control option',
    yilaiOption: 'Depend on the options',
    optionControlInfo:
      'Applies to a drop-down options type field, which controls whether the following fields are displayed or not.',
    optionControl: 'Option control',
    option: 'option',
    referenceField: 'Reference field',
    checkedReferenceShow: 'Check the correlation display.',
    pleaseSelectOptionList: 'Select the drop-down options for the options field first.',
    pleaseSelectControlList: 'Please select the drop-down options for the control field first.',
    dataLinkageInfo: 'Precompute (preprocess) the existing form data for further calls.',
    linkageForm: 'linkage form',
    linkageContion: 'linkage contion',
    linkageField: 'linkage field',
    dataLinkage: 'Data linkage',
    triggerLinkageField: 'Trigger linkage field',
    thisModule: 'This module',
    valueEqualTo: 'Value equal to',
    valueTime: 'Value of',
    value: 'Value of',
    linkageShow: 'Linkage show',
    linkageFormNotEmpty: 'Linkage form cannot be empty.',
    linkageContionNotEmpty: 'Linkage contion cannot be empty.',
    linkageFieldNotEmpty: 'Linkage field cannot be empty.',
    subformOptionMappingInfo:
      'Apply to the master-subtable association mapping, generate buttons in the subform, filter through the master-table association, and then insert the data of the subform in bulk.',
    subformOptionMapping: 'Subform option mapping',
    thisModuleSubform: 'This module subform',
    referenceSubform: 'Reference subform',
    filterContion: 'Filter condition',
    addFilterContion: 'Add filter contion',
    subformMappingGuanxi: 'Subform mapping',
    selectSubfrom1: 'Please select the subform for this module.',
    selectSubfrom2: 'Please select the associate subform.',
    fieldTransfer: 'Field transfer',
    fieldTransferInfo:
      'The fields are converted to the corresponding other module, and these mappings are used for the conversion.',
    addFieldTransfer: 'Add field transfer',
    baseInfo: 'Basic information ',
    sourceModule: 'Source module',
    targetModule: 'Target module',
    ifDelSourceRecord: 'Whether to delete the original record?',
    fieldDuiyingGuanxi: 'Field correspondence',
    selectSubfrom: 'Select subfrom',
    selectTransferTargetModule: 'Select the target module for the transformation.',
    cancelDel: 'Cancel deletion',
    autoMarkColor: 'Automatic marking color',
    autoMarkColorInfo: 'Automatically color-marks data that meets a condition.',
    markColor: 'Mark color',
    showColor: 'Display Color',
    customPrint: 'Custom print',
    customPrintInfo:
      'When printing module data, you can choose the template format set for printing.',
    templateName: 'Template name',
    type: 'Type',
    uploadTemplate: 'Upload template',
    addFile: 'Add file',
    exportTemplate: 'Export template',
    exampleTemplateDown: 'Sample template download',
    printTemplate: ' Print template',
    uploadXlsFile: 'Please upload the XLS type file.',
    uploadDocxFile: 'Please upload docx type files.',
    uploadPrintTemplate: 'Please upload the print template.',
    delTemplateIsGoon: 'This action will permanently delete the template, whether to continue?',
    outLink: 'Outlink',
    outLinkInfo:
      'Publish the data as a separate public link to access the data without logging in.',
    openOutLink: 'Open outLink',
    dataVisitAuth: 'Data access rights',
    openVisit: 'Open visit',
    pwdVisit: 'Access by password ',
    fieldVisitAuth: 'Field access rights',
    setDataOutLink: 'Set data outlink',
    dataInnerLink: 'Data inner link',
    openDataInnerLinkInfo:
      'Open the data internal chain, and directly access the data through the Mobile APP scan function.',
    openDataInnerLink: 'open data inner link',
    sameFieldOutLink: 'Which fields of this module can be externally linked to the data?',
    fieldName: 'Field name',
    accessible: 'Accessible',
    selectVisitField: 'Select accessible fields',
    setPwd: 'Set a password',
    submitCheck: 'Submit check',
    tipsText: 'Placeholder',
    shortmessageTemplate: 'Short message template',
    shortmessageTemplateInfo:
      'Set validation rules for field values to prevent irregular data entry.',
    addTemplate: 'Sdd template',
    templateContent: 'Template content',
    failBeacuse: 'Cause of failure',
    shortMessTem25: 'Please enter a name, and no more than 25 Chinese characters.',
    selsectSigntrue: 'Select the signature',
    pleaseSelsectSigntrue: 'Select the signature please.',
    insertVar: 'Insert the variable',
    tamplateNameRequried: 'Tamplate name requried',
    tamplateContentRequried: 'Tamplate content requried',
    applicationNotesRequried: 'Application notes requried',
    tamplateSigntrueRequried: 'Tamplate signtrue requried',
    applicationNotes: 'Application notes',
    shortmessTemMsg1: 'Please briefly describe your business scenario in no more than 100 words.',
    shortmessTemMsg2:
      'A total of 19 words (including signature and parentheses), 1 SMS (due to the variables, according to the actual length of the billing;If less than 70 words (including 70 words), it shall be counted as 1 piece. If more than 70 words, it shall be charged as 1 piece of 67/ word.',
    shortmessTemMsg3:
      'SMS template needs to be reviewed. Working hours for review: 9:00-23:00 from Monday to Sunday (legal holiday will be postponed).',
    fieldIsNotInputAgain:
      'The field does not exist, and please readjust the contents of the template.',
    sureDelShorMesTemplate: 'Are you sure you want to delete the SMS template?',
    delSuccessDontHuifu: 'After successful deletion, the operation cannot be recovered.',
    subMenu: 'Submenu',
    subMenuInfo: 'Maintain the custom submenus that have been created.',
    query: 'Query',
    sureDelData: 'Are you sure you want to delete this data?',
    tagManage: 'Tag manage',
    tagManageInfo: 'Precompute (preprocess) the existing form data for further calls.',
    lookAllData: 'All associated data is visible.',
    lookAuthData: 'Data within visible data permissions',
    show: 'Display',
    hidden: 'Hidden',
    controlModule: 'Control module',
    controlContion: 'Control contion',
    addRule: 'Add rule',
    newBuildRule: 'New-buildly rule',
    tabManageMsg1:
      'Make sure that the values of the selected fields are not repeated in the current module.',
    tabManageMsg2: 'Otherwise the TAB may duplicate on the data.',
    defaultContion: 'Implied condition ',
    showTange: 'visible range ',
    tabStatus: 'TAB state',
    dayu: 'More than',
    xiaoyu: 'Less than',
    dayudengyu: 'Equal or greater than',
    xiaoyudengyu: 'Less than or equal to ',
    dengyu: 'Equal to',
    budengyu: 'Unequal to',
    baohan: 'Include',
    beibaohan: 'Be included in',
    bubaohan: 'Do not contain',
    bubeibaohan: 'Not included in',
    leijia: 'Add up',
    koujian: 'Deduction ',
    fixedValue: 'Fixed value',
    dynamicValue: 'Dynamic value',
    controlModuleNotEmpty: 'The control module cannot be empty.',
    controlContionNotEmpty: 'The control condition cannot be null.',
    topSuccess: 'Top success',
    editRule: 'Edit rules',
    tabDelRule:
      'Modules controlled by this rule are removed from the custom module name TAB after deletion.',
    sureTabDelRule: 'Are you sure you want to remove the check rule?',
    others: 'Others',
    reference: 'Reference',
    matchAuto: 'Matching automation',
    matchAutoInfo: 'Automatically get the qualified data through the set matching rules',
    highSeasPool: 'The high seas pool',
    oneDayUpperLimit: 'daily collection limit',
    UpperLimit: 'Upper limit',
    administrators: 'Administrators',
    secrecyField: 'Secrecy field',
    dontInputInfinite: ' Blank is infinite.',
    addField: 'Add field',
    recoveryRule: 'Recovery rules',
    notRecovery: 'Not recycle ',
    recovery: 'Recovery',
    zhixingPinglv: 'Execution frequency',
    everyday: 'Every Day',
    everyday0clock: "Execute at 0 o 'clock every day.",
    highseaspoolPwd: 'Secure control of phone and email components in the high seas pool',
    selectPwdField: 'Select the fields that you want to keep confidential.',
    inputHighseaspollName: 'Please fill in the name of the high seas pool.',
    memberRequried: 'member requried',
    adminRequried: 'admin requried',
    highseaspollNameishave: 'The high seas pool name already exists.',
    limintmax: 'The collection limit shall not be less than the daily collection limit.',
    huishouRequried: 'If recycling is selected, the recycling rule condition is mandatory.',
    notSeasRule: 'Not high seas pool rules',
    returnHighseaspoll: 'Return to high seas pool',
    pleaseInputName: 'Please input name',
    notSeasRuleIshave: 'The non-high seas pool rule already exists.',
    recoveryRuleRequried: 'Recovery rules requried',
    returnHighseasRequried: 'Returned high seas pool requried',
    noticePush: 'Notice push',
    noticePushInfo: 'Sends a message to the specified member based on a condition.',
    disable: 'Disable',
    enable: 'Enable',
    trigger: 'Trigger',
    remindTime: 'Remind time',
    beiRemindPer: 'Reminder',
    remindContent: 'Remind content',
    triggerEvent: 'Trigger event',
    anyField: 'Any field',
    zhidingField: 'Specified field',
    zhidingFieldSet: 'Specified field settings',
    thisDay: 'This day',
    before: 'Before',
    after: 'After',
    repeatReminder: 'Repeated reminder frequency',
    remindEndtiem: 'Reminder end time',
    remindFangshi: 'Remind way',
    selectShormsgTemplate: 'Select SMS template',
    emailContent: 'Email content',
    eventHappen: 'When the event occurs.',
    customRemindTime: 'Custom reminder time',
    remindType: 'Remind type',
    remindPinglv: 'Remind frequency',
    every: 'Every',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    endTime: 'End time',
    Happen: 'Happen',
    cizhihou: 'After a time',
    result: 'Result',
    pushContent: 'Push content',
    selectHappenTrigger: 'Select the fields that trigger alerts when editing data.',
    neverGameOver: 'Never end',
    cishu: 'Times',
    zhidingDate: 'Appointed day',
    dateTimeField: 'Date/time field',
    onlyOneRmind: 'Only one remind',
    dayRemind: 'Remind everyday',
    weekRemind: 'Remind weekly',
    monthRemind: 'Reminf monthly',
    yearRemind: 'Remind yearly',
    addData: 'Add data',
    receivedNewYaoqing: 'Receive new client collaboration invitations',
    never: 'Never',
    date: 'Date',
    hao: 'Day',
    themeMustFill: 'Topic is required.',
    senderMustFill: 'The sender is required.',
    addresseeeMustFill: 'The recipient is required.',
    emailContentMustFill: 'The content of the email is required.',
    pleaseZhidingField: 'Select the specified field.',
    pleaseZhidingTiem: 'Please select the reminder time.',
    noticePushMsg1: 'Remind time and day are positive required integers.',
    noticePushMsg2: 'The end of the reminder is a positive integer.',
    noticePushMsg3: 'Reminder end specified time is required.',
    noticePushMsg4: 'Select the reminder end time field.',
    noticePushMsg5: 'Remind end time days are required positive integers.',
    noticePushMsg6: 'Please add email content.',
    noticePushMsg7: 'Remind people cannot empty.',
    noticePushMsg8: 'Adding new rules successful.',
    noticePushMsg9: 'Deleting rules successfully.',
    noticePushMsg10: 'This action disables the rule, continue or not?',
    noticePushMsg11: 'This action will enable the rule, continue or not?',
    everyDay9DontOver: "Every day doesn't end at 09:00.",
    maxThreeDate: 'You can add up to three pieces of data.',
    receiveNew: 'Receive new',
    receiveShare: 'Receive share',
    benzhuanhuanNewData: 'Be converted to new module data',
    receiveTransfer: 'Receive transferred',
    beiDel: 'Bedeleted',
    beiEdit: 'Data is modified.',
    beiCommon: 'Be commented ',
    quickGenjin: 'Please timely follow up.',
    neverOver: 'Not end',
    ciOver: 'End of the time',
    over: 'Over',
    workflowAtuo: 'Workflow automation',
    workflowAtuoInfo:
      'Automatically execute the set business process for the records that meet the requirements;Automation involves field updates, automatic allocation of field conversion reminders, and so on.',
    start: 'Start',
    plus: 'Plus',
    reduce: 'Minus',
    newBuildUpdaInfo: 'Update or create new data based on filter conditions',
    operationMode: 'Operation mode',
    addAndUpdateData: 'Add and update data',
    updateData: 'Update data',
    isApprovalProcess: 'Whether to initiate an approval flow?',
    businessOperation: 'Business operation',
    addOperation: 'Add operation',
    targetModuleMustfill: 'The target module is mandatory.',
    nameMustfill25: 'The name is mandatory and less than 25 words.',
    approvalProcessInfo:
      'There is no designated leader in the initiation approval process. Please configure the corresponding leader relationship in the business operation.',
    matchCondNotall: 'The matching condition is not perfect.',
    filterCondNotall: 'The filtration condition is not perfect.',
    bussinessOpreationNotall: 'Business operations are imperfect.',
    tuijianModule: 'Recommend the module',
    updateTime: 'Update time',
    autoMatchCondNotEmpty: 'The automatic matching condition cannot be null.',
    custonBottonInfo: 'By defining what to do when the user clicks the button',
    custonBotton: 'Custom button',
    name: 'Name',
    buttonName: 'Button name',
    buttonUser: 'Button users',
    addUserDepRole: 'Add members, departments, roles',
    buttonShowPosition: 'Position display button',
    buttonShowContion: 'Button display conditions',
    AlwaysShow: 'Always show',
    thisCotntionShow: 'Display when the following conditions are met',
    clickButtonShowPop: 'Do you need to pop up to fill in the content after clicking the button:',
    noNeed: 'Unwanted',
    need: 'Need',
    customButtonTips:
      'Prompt text (if the prompt text is empty, it means that no pop-up prompt is required and the follow-up rules are executed directly)',
    determineNeedTriggeContent: 'After confirmation, the update content needs to be triggered',
    detailsPage: 'Details page',
    listPage: 'List page',
    addNoduleData: 'New module data',
    fieldUpdateTrigge: 'Field update - trigger background rule',
    openUrl: 'Jump Link',
    initiateApproval: 'Initiate approval',
    jumpSystem: 'Jump Link',
    isJumpPolaris: 'Jump to Polaris',
    jump: 'Jump',
    notJump: 'Do not jump',
    polarisLink: 'Polaris Link',
    pleaseInputPolarisLink: 'Please enter the Polaris link',
    pleaseInputButtonName: 'Please fill in the name of the button',
    pleaseSelectButtonUser: 'Please select the user of the button',
    pleaseSelectButtonPostion: 'Please select the display position of the button',
    popSelectOneFiled: 'Select at least one field in the pop-up window',
    pleaseSelectTriggeModule: 'Please select the target module',
    pleaseSelectJumpSystem: 'Please fill in the jump link',
    roleAuth: 'Role permissions',
    pageAuth: 'Page permissions',
    fieldDependent: 'Field dependency',
    optioneFieldControl: 'Option field control',
    recordStyle: 'Record style',
    highSeasManage: 'High seas management',
    notHighSeasRule: 'Non high seas rules',
    externalLinks: 'External links',
    viewManage: 'View management',
    checkRepeatSettings: 'Duplicate check settings',
    checkRepeatInfo:
      'By means of complex rechecking rules, the duplicate information of human operation can be excluded',
    dongtaiTime1: 'Dynamic time division - ahead',
    dongtaiTime2: 'Dynamic time division - delay',
    wechatNoticeInfo:
      'This method is only effective for employees who are bound to WeChat public number, and employees who are not bound to WeChat public number cannot receive the message push. If you want to bind WeChat public number, please go to [system management] - [Basic information] to access the configuration of WeChat public number',
    fenbieSend: 'Individually send',
    teshuMember: 'Special members',
    teshuMember1: 'Special members receive the upper limit',
    teshuMember2: 'Daily limit for special members',
    teshuMember3: 'Claim restriction',
    teshuMember4:
      'Note: After the data is returned or the system periodically reclaims the high seas pool, the former responsible person cannot receive the data after N days.',
    teshuMember5: 'Cannot receive the same data continuously within days',
    highseaJudge1: 'Members receive an upper limit of positive integers',
    highseaJudge2: 'Members can receive up to a positive integer per day',
    highseaJudge3: 'The upper limit for special members is a positive integer',
    highseaJudge4: 'The daily limit for special members is a positive integer',
    highseaJudge5: 'The draw limit is a positive integer',
    highseaJudge6: 'Special members can not receive less than the daily limit of special members',
    highseaJudge7: 'Take the maximum limit input value of 100',

    // 2020-12-25
    searchTargetModuleUpdate: 'Query the target module data and update it to this module',
    emailTemplateSet: 'Email reminder template',
    emailContentRemind: 'Email reminder content',
    referenceYilaiInfoNew:
      'It is applied to fields of "association relationship" and "Department - single selection" types to realize data filtering between two association relationships and between two departments',
    gobackBusinessFlow: 'Back to the enterprise workflow',
    BusinessFlowSet: 'Enterprise workflow Settings',
    scheduleDataInfo1:
      'The calendar/to-do tasks map component presents the event/practitioner Settings',
    scheduleDataInfo2:
      'The calendar/to-do tasks diagram component completes the status set, and the completed data is marked with an underscore as completed',
    scheduleDataInfo3: 'The calendar/to-do tasks map card shows field Settings',
    scheduleDataInfo4:
      'Push to the portal based on form data: calendar/to-do tasks diagrams are not allowed to create multiple',
    scheduleDataInfo5: 'Incorrect completion status setting for calendar/to-do tasks map component',

    // 2021-04-08
    everyMinute: 'Every minute',
    triggerTiming: 'The trigger timing',
    breakTimeTrigger: 'Trigger shutdown periodically during rest time',
    offDutyDay: 'Off day',
    offHours: 'Off hours',
    noonBreak: 'Noon break',
    offHolidays: 'The shutdown is triggered periodically on statutory holidays',
    selectOffDutyDay: 'Please select a non-working day',
    selectOffHours: 'Please select a non-working time',
    selectNoonBreak: 'Please select a break time at noon',
    btnColor: 'The button color',
    smartPlugInfo:
      'Before using this function, please go to [Interface Integration] - [third-party Platform] - [Ali Cloud Integration] to set the corresponding Ali Cloud interface account.',
    smartPlugTitle:
      'To use this function, please go to "Interface Integration" menu - "Third-party Platform" TAB to set, and then use it',
    idCardShibie: 'Id card real-name identification',
    businessInfoSearch: 'Business Information Enquiry',
    sureCloseAndClear:
      'Are you sure you want to shut it down? Field Settings will be cleared when closed',
    idCardRequired: 'Id card information Mandatory',
    companyNameRequired: 'Enterprise name This parameter is mandatory',
    payFieldRequired: 'The payment field is mandatory',
    namePictureIdcard: 'Picture + name + id card real-name identification',
    verifyPictureNameIDcard:
      'Used to verify that the picture, name and ID number match. Mandatory.',
    mapModeSettings: 'Map Mode Settings',
    mapMode: 'Map mode',
    showTabModule: 'Displays the TAB module',
    mapModeSettingsTips:
      'Use to display the number of other TAB modules under the location map and support the number of clicks to view the list, such as contacts under the customer.',
    selectTabModule: 'Select the TAB module',
    SubordinateTheStage: 'Subordinate to the stage',
    mapModeTip1: 'There are mandatory items not filled in for location map function',
    mapModeTip2: 'Some mandatory items are left unfilled in the page module',
    deleteSchedule: 'Delete the schedule',
    deleteDataTriggerAdd: 'Deletes the new schedule triggered by the current data',
    deleteScheduleRequired: 'Delete Schedule Mandatory',
    constFieldRequired: 'The constant field is mandatory',
    oprationPaymentSetTip:
      'The trigger event for the operation set account period must be after the new record is saved',
    PaymentDaysSet: 'Payment days set'
  }
}
